import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class EventCalendarService {
  changedActiveMonth = new Subject<any>();
  setActiveMonth = new Subject<Date>();
}
